<template>
  <b-container>
    <template-breadcrumb-header-action-element>
      <template #content>
        <div class="exportPDF">
          <a
            :href="
              urlApi +
              '/pdf/evaluation-report/' +
              getToken +
              '/' +
              (evaluationData &&
                evaluationData.businessId &&
                evaluationData.businessId.length &&
                evaluationData.businessId[0]) +
              '/' +
              evaluationId +
              '/' +
              getCurrentAccountRoleId +
              '/' +
              lang
            "
            target="_blank"
            size="sm"
            variant="primary"
            :title="$t('label_download_PDF')"
            ><img width="40" src="/static/icons/PDF.svg"
          /></a>
        </div>
      </template>
    </template-breadcrumb-header-action-element>
    <b-row>
      <b-col class="mt-2">
        <evaluation-model-header
          :data="data"
          :evaluation-data="evaluationData"
        />
        <div class="cardContainer evaluationHeader" style="padding: 30px">
          <h4>{{ $t("label_evaluation_report_evaluationSummary") }}</h4>
          <div v-html="evaluationData.evaluation.summary" />
        </div>

        <card-evaluation-report-chart-treemap
          alias="treemap"
          :evaluation="data"
          style="margin-bottom: 15px"
        />

        <div class="cardContainer evaluationHeader" style="padding: 30px">
          <h4>{{ $t("label_evaluation_report_scoreByDimensions_title") }}</h4>
          <evaluation-report-tree-list :tree="data" />
        </div>
        <div class="cardContainer evaluationHeader" style="padding: 30px">
          <h4>{{ $t("label_evaluation_report_scoreByDimensions_title") }}</h4>
          <evaluation-report-tree-list-graph :tree="data" />
        </div>
        <div class="cardContainer evaluationHeader" style="padding: 30px">
          <h4>{{ $t("label_evaluation_opportunitiesImprovement_title") }}</h4>
          <div v-if="evaluationData.evaluation.improvements">
            <div
              v-for="(improvementE, improvementEIndex) in evaluationData
                .evaluation.improvements"
              :key="improvementEIndex"
              style="
                margin-bottom: 20px;
                border-bottom: 1px solid #636363;
                padding-bottom: 20px;
              "
            >
              <div>
                <h6>
                  {{improvementE.evaluation_opportunitiesImprovement_askForTitle}}
                </h6>
              </div>
              <div>
                <div>
                  <div class="h7">
                    {{$t("label_evaluation_opportunitiesImprovement_whatWasFound")}}
                  </div>
                </div>
                <div>
                  {{improvementE.evaluation_opportunitiesImprovement_whatWasFound}}
                </div>
                <div>
                  <div class="h7">
                    {{$t("label_evaluation_opportunitiesImprovement_whereWasFound")}}
                  </div>
                </div>
                <div>
                  {{improvementE.evaluation_opportunitiesImprovement_whereWasFound}}
                </div>
                <div>
                  <div class="h7">
                    {{$t("label_evaluation_opportunitiesImprovement_affectedRequirements")}}
                  </div>
                </div>
                <div>
                  <div
                    v-for="(req, reqIndex) in improvementE.nodesToImprove"
                    :key="reqIndex"
                  >
                    <b>{{ req.evaluation_administrator_node_nomenclature }}</b>
                    {{ req.evaluation_administrator_node_requirementName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-card
          v-if="allComments.length"
          class="cardContainer evaluationHeader"
          style="padding: 30px"
        >
          <h4>
            {{
              $t(
                "label_evaluation_report_disaggregatedResultsByDimensions_title"
              )
            }}
          </h4>
          <evaluation-report-comments v-if="data" :tree="data" />
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script >
import { Tree } from "../../../../utils/vue-tree-list";
import EvaluationModelHeader from "../shared/EvaluationHeader";
import EvaluationReportTreeList from "./EvaluationReportTreeList";
import EvaluationReportTreeListGraph from "./EvaluationReportTreeListGraph";
import EvaluationReportComments from "./EvaluationReportComments";
import CardEvaluationReportChartTreemap from "./CardEvaluationReportChartTreemap"
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";
import {getBackendHostBaseUrl} from "@/utils/urlConfig";

export default {
  name: "EvaluationReport",
  components: {
    EvaluationReportComments,
    EvaluationReportTreeListGraph,
    EvaluationReportTreeList,
    EvaluationModelHeader,
    CardEvaluationReportChartTreemap
  },
  data: function () {
    return {
      allComments: [],
      urlApi: getBackendHostBaseUrl(),
      data: new Tree([]),
      loading: true,
      evaluationId: this.$route.params.idEvaluation,
      evaluationData: { evaluation: {} },
      status: "success",
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters(["getBusiness", "getToken", "getCurrentAccountRoleId"]),
  },
  async created() {
    await axiosCall({ url: "UserAccounts/get", method: "GET" }).then(
      (account) => {
        this.account = account.data;
      }
    );
    await axiosCall({
      url: "Evaluations/" + this.evaluationId,
      method: "GET",
    }).then((response) => {
      this.evaluationData = response.data;
      this.evaluationData.evaluation.summary = this.evaluationData.evaluation
        .summary
        ? this.evaluationData.evaluation.summary.replace(
            /(?:\r\n|\r|\n)/g,
            "</br>"
          )
        : "";
      if (
        this.evaluationData.evaluation &&
        this.evaluationData.evaluation.children &&
        Array.isArray(this.evaluationData.evaluation.children)
      ) {
        this.data = this.evaluationData.evaluation;
        this.$forceUpdate();
      }
    });
    this.extractAllComments(this.data, []);
  },
  methods: {
    extractAllComments(node, deepTree) {
      if (node.children && node.children.length > 0) {
        if (node.evaluation_administrator_node_requirementName) {
          deepTree.push({
            nom: node.evaluation_administrator_node_nomenclature,
            name: node.evaluation_administrator_node_requirementName,
          });
        }
        node.children.map((child) =>
          this.extractAllComments(child, [...deepTree])
        );
      } else {
        const visibleComments = (node.comments || []).filter(
          (comment) =>
            comment.scope ===
            "label_evaluation_requirementEvaluation_post_includeInFinalReport"
        );
        if (visibleComments.length > 0) {
          this.allComments.push({
            comment: visibleComments,
            indicator:
              node.evaluation_administrator_node_matrix_indicator_indicator,
            tree: deepTree,
          });
        }
      }
    },
  },
};
</script >

<style lang="scss" scoped>
h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
  text-align: center;
}
@import "../../../../assets/css/variables";

.cardContainer {
  border: 1px solid #000000;
  width: 100%;
  padding: 30px 40px;
  margin-bottom: 15px;
}
h2 {
  color: black;
  margin: 1em 0;
}
.label {
  font-weight: bold;
  font-size: 14px;
}
.h7 {
  font-weight: bold;
  margin-top: 15px;
}
h6 {
  font-family: 'Montserrat-Bold';
}
</style >
